define('charts/flight-stats',["require", "exports", "../tracks/track-state", "./dataseries"], function (require, exports, trackState, dataseries) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(toggleable) {
        var _loop_1 = function (flightStat) {
            flightStat.statElement = document.getElementById(flightStat.statElementId) || undefined;
            if (flightStat.statElement && flightStat.hotkey) {
                var labelElement = flightStat.statElement.parentElement.querySelector("label");
                if (toggleable) {
                    labelElement.addEventListener("click", function () {
                        // Toggle data series
                        flightStat.enabled = !flightStat.enabled;
                        dataseries.seriesUpdates.post(flightStat);
                    });
                }
                else {
                    labelElement.classList.add("noclick");
                }
                updateSeries(flightStat);
            }
        };
        // Find html elements
        for (var _i = 0, _a = dataseries.all; _i < _a.length; _i++) {
            var flightStat = _a[_i];
            _loop_1(flightStat);
        }
        // Listen for focus updates
        trackState.focusUpdates.subscribe(drawFocus);
        // Listen for data series toggling
        dataseries.seriesUpdates.subscribe(updateSeries);
    }
    exports.init = init;
    function drawFocus(d, track) {
        for (var _i = 0, _a = dataseries.all; _i < _a.length; _i++) {
            var flightStat = _a[_i];
            if (flightStat.statElement) {
                flightStat.statElement.innerText = d ? flightStat.localString(d, track) : "";
            }
        }
    }
    function updateSeries(flightStat) {
        if (flightStat.statElement) {
            if (flightStat.enabled) {
                flightStat.statElement.parentElement.classList.remove("disabled");
            }
            else {
                flightStat.statElement.parentElement.classList.add("disabled");
            }
        }
    }
});
//# sourceMappingURL=/assets/javascripts/charts/flight-stats.js.map;
